import * as React from "react";
import {
    CAROUSEL_BANNERS,
    Policy,
    Quote,
    ProductsEnum,
    resourcesHelper,
    GET_NEW_QUOTE_PATH
} from "@falcon/services";
import {hasActiveMotorPolicy} from "../../../CommonFunctions";
import {pushClickEvent} from "./carouselEvents";
import {Link} from "react-router-dom";

interface IProps {
    policy: Policy;
    policies?: Policy[];
    quotes?: Quote[];
    newCarQuotePopUp: any;
}

export class GetCarQuoteCarouselBanner extends React.Component<IProps> {

    public render() {
        const isActiveMotorPolicy = hasActiveMotorPolicy(this.props.policies || [this.props.policy]);
        const isQuotePeriodValid = this.hasValidCarQuote();
        const validQuoteLinkWording = isActiveMotorPolicy
            ? this.getMoreCarsWording()
            : this.getCarQuoteWording();

        return (
            <div className="carousel-banner banner-content">
                <img className={`banner-icon ${isActiveMotorPolicy ? "cars-icon" : ""}`}
                     src={isActiveMotorPolicy ? this.getCarsIcon() : this.getCarIcon()}
                     alt="Car icon"/>
                <div className="banner-text">
                    <div className="banner-title mb-3">
                        {isActiveMotorPolicy? this.getMoreCarsWording() : this.getCarCoverWording()}
                    </div>
                    {isActiveMotorPolicy ? this.getSecondCarWording() : this.getNoCarWording()}
                    <p className="mt-3">
                        <img className="carousel-banner-arrow" src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}
                             alt="Arrow icon"/>
                        {!isQuotePeriodValid ? (
                            <button className="btn-text cursor-pointer" onClick={() => this.onClick()}>
                                Get a new car quote
                            </button>
                            ) : (
                                <Link
                                    className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                                    onClick={this.onClick}
                                    to={{pathname: GET_NEW_QUOTE_PATH}}>
                                    {validQuoteLinkWording}
                                </Link>
                        )}
                    </p>
                </div>
            </div>
        )
    }

    private getNoCarWording(): React.JSX.Element {
        const voucherIncentiveEnabled: boolean = process.env.REACT_APP_MOTOR_VOUCHER_INCENTIVE_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_VOUCHER_INCENTIVE_ENABLED) : false;

        return (
            <p>
                Cover the basics with {resourcesHelper.TIER_1} or choose our Defaqto 5 Star {resourcesHelper.TIER_2} or {resourcesHelper.THEME === 'Britannia' ? resourcesHelper.PRODUCT_TIER_3 : resourcesHelper.TIER_3} cover.
                {voucherIncentiveEnabled && (
                    <>
                        {' '}Get a quote by 30/11/26 and you could <span className="font-weight-bold">win a £50 Amazon voucher</span>.{' '}
                        <a
                            href={"https://cloud.comms.allianz.co.uk/homepromotcs2026"}
                            className="text-decoration-underline muli-bold-16-blue"
                        >
                            T&Cs
                        </a>
                        {' '}apply.
                    </>
                )}
            </p>
        );
    }

    private getSecondCarWording(): React.JSX.Element {
        const voucherIncentiveEnabled: boolean = process.env.REACT_APP_MOTOR_VOUCHER_INCENTIVE_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_VOUCHER_INCENTIVE_ENABLED) : false;

        return (
            <p>
                Got another car you'd like covered? We'll give you a quick quote based on your existing policy.
                {voucherIncentiveEnabled && (
                    <>
                        {' '}Get a quote by 30/11/26 and you could even <span className="font-weight-bold">win a £50 Amazon voucher</span>.{' '}
                        <a
                            href={"https://cloud.comms.allianz.co.uk/homepromotcs2026"}
                            className="text-decoration-underline muli-bold-16-blue"
                        >
                            T&Cs
                        </a>
                        {' '}apply.
                    </>
                )}
            </p>
        );
    }

    private getMoreCarsWording(): string {
        return "Cover your other cars";
    }

    private getCarQuoteWording(): string {
        return "Get a car quote";
    }

    private getCarCoverWording(): string {
        return `${resourcesHelper.PRODUCT} Car Insurance Quote`;
    }

    private getCarIcon(): string {
        return `/${resourcesHelper.THEME}/img/wolf-car-icon.png`;
    }

    private getCarsIcon(): string {
        return `/${resourcesHelper.THEME}/img/cars-icon.svg`;
    }

    private hasValidCarQuote(): boolean {
        const quotes: Quote[] = this.props.quotes || [];
        return quotes.some((quote: Quote) =>
            quote.product === ProductsEnum.WOLF_MOTOR
        );
    }

    private onClick() {
        const isQuotePeriodValid = this.hasValidCarQuote();
        if (isQuotePeriodValid) {
            pushClickEvent(
                CAROUSEL_BANNERS.getCarQuote.name,
                GET_NEW_QUOTE_PATH,
                CAROUSEL_BANNERS.getCarQuote.id
            );
            return;
        }
        pushClickEvent(
            CAROUSEL_BANNERS.getCarQuote.name,
            `/journey/show/product/${ProductsEnum.WOLF_MOTOR}/process/nb`,
            CAROUSEL_BANNERS.getCarQuote.id
        );
        if (this.props.newCarQuotePopUp) {
            this.props.newCarQuotePopUp();
        }
    }
}
